<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue-router/dist/vue-router.js"></script>

<template>
	<div id="header-bar">
	<span class="p-grid head-grid">
		<div id="header-logo" class="p-col-3 p-md-3 p-lg-3 p-xl-3">
			<a href="https://www.vdpresearch.de" target="_blank">
				<img @click="activateMain()" class="" :src="baseUrl + headerData[0].companyLogo.url"/>
			</a>
		</div>
		<div class="light-text p-col-9 p-md-7 p-lg-8 p-xl-9">
			<div id="header-content" class="p-grid">
				<label id="feature-label" @click="activateMain('feature')" class="p-col-12 p-sm-12 p-md-12 p-lg-3 p-xl-2 ">
					<router-link :to="{ name:'home', params: { newLocation: 'feature'}}">
						<a href="#feature" class="clickable">
							<p>{{content1}}</p>
						</a>
					</router-link>
				</label>

				<label @click="activateMain('product')" class="p-col-12 p-sm-12 p-md-4 p-lg-3 p-xl-2 ">
					<router-link :to="{ name:'home', params: { newLocation: 'product'}}">
						<a href="#product" class="clickable">
							<p>{{content2}}</p>
						</a>
					</router-link>
				</label>

				<label id="login-label" class="p-col-12 p-sm-12 p-md-4 p-lg-3 p-xl-2 ">
					<a href="https://demo.cibplus.de/cibplus-webui" class="clickable" target="_blank">
						<p>{{content3}}</p>
					</a>
				</label> 
			</div>
		</div>
	</span>
	</div>
</template>

<script>

import JsonProvider from '../../../services/DataService.js';
import {configData} from '../../../services/DataService.js';

	export default {
		name: 'LandingHeaderBar',
		data: 
			function() { 
			return {
				content1: "Features",
				content2: "Produkt",
				content3: "Demo",
				featureParam:"feature", 
				productParam:"",
				headerData: [],
			}
		},

		props: {isMain: false},

		methods: {
			activateMain(ref) {
			if(this.isMain){
				if(ref == "feature")
				this.$emit('scrollFeature');
				if(ref == "product")
				this.$emit('scrollProduct');
			}
		}
	},
		created: async function() {
			var jsonGetter = new JsonProvider();
			this.headerData = await jsonGetter.fetchJsonObject('general-infos');
			this.baseUrl = configData.baseUrl.data.baseUrl;
	}
}

</script>
<style scoped>

	#header-bar {
		display: flex;
		padding-top: 1em;
		margin-left: auto;
		margin-right: auto;
	}

	#header-logo {
		margin: 2em;
		margin-left:3em;
		margin-top: 1em;
		height: 60px;
		width: 196px;
		z-index: 10;
	}


	#header-content {
		justify-content: space-around;
		margin-left: -8em;
		display: flex;
		flex-direction: row;
	}

	.clickable :hover {
		color: #c71748;
	}
	
	@media (max-width: 1199px) {
		#feature-label {
		margin-right: -20em;
		}
	
	#login-label {
		margin-left: -20em;
		}
	}

	@media (min-width: 1200px) {
		#feature-label {
		margin-right: -35em;
		}

	#login-label {
		margin-left: -35em;
		}
	}
	
	@media (max-width: 991px) {
		#header-content {
		justify-content: space-between;
		margin-left: -2em;
		}
	}
	
	@media (max-width: 767px) {
		#header-content {
			display: none;
		}

		#header-bar {
			margin-bottom: 0;
			width: 100%;

		}
		
		#header-bar > span {
			display: block;
			text-align: left;
			width: 90%;
		}
		#header-logo {
			margin: auto;
			float: left;
			padding-left: 0;
		}
	}

	label {
	width: auto;
	margin: 0;
	}

	.head-grid {
		width: 100%;
		max-width: 1500px;
		margin: auto;
	}

	p {
		font-size: 1.35em;
	}
	
		a {
		color: #2c3e50;
		text-decoration-line: none;
		z-index:1;
	}


</style>



